import { z } from 'zod';
import { VALIDATION_MESSAGES } from './validationMessages';

export const requiredString = () => z
  .string({
    required_error: VALIDATION_MESSAGES.REQUIRED_FIELD,
    invalid_type_error: VALIDATION_MESSAGES.REQUIRED_FIELD,
  })
  .min(1, VALIDATION_MESSAGES.REQUIRED_FIELD);

export const selectOption = () => z.object({
  label: z.string(),
  value: z.string(),
}, {
  required_error: VALIDATION_MESSAGES.REQUIRED_FIELD,
});

export const selectNumberOption = () => z.object({
  label: z.string(),
  value: z.number(),
}, {
  required_error: VALIDATION_MESSAGES.REQUIRED_FIELD,
});
